import GenericListPanel from "./GenericListPanel";

const ICONS = ["building", "warehouse", "fence", "flame", "wrench", "hammer", "shield"];

export default function ServicesPanel() {
  return (
    <GenericListPanel
      endpoint="services"
      testidPrefix="services"
      eyebrow="03"
      title="Services"
      description="The service cards displayed on the homepage."
      emptyItem={{ title: "", description: "", icon_key: "building", image_url: "", image_data: null, order: 0 }}
      fields={[
        { name: "title", label: "Title", type: "text" },
        { name: "description", label: "Description", type: "textarea" },
        { name: "icon_key", label: "Icon", type: "select", options: ICONS },
        { name: "image_url", label: "Image", type: "image" },
      ]}
    />
  );
}
